import { Component, computed, input } from '@angular/core'

@Component({
  selector: 'ftr-search-results-navigation',
  templateUrl: './search-results-navigation.component.html',
  styleUrls: ['./search-results-navigation.component.css'],
})
export class SearchResultsNavigationComponent {
  searchTerm = input.required<string>()
  numberOfItemsInPage = input.required<number>()
  totalItems = input.required<number>()
  offset = input.required<number>()

  protected pageStart = computed(() => this.offset() + 1)
  protected pageEnd = computed(() => this.offset() + this.numberOfItemsInPage())
}
